import React, { useState, useEffect } from "react";
import Loading from "../../common/Loading";
import RightFooter from "../../common/RightFooter";
import {Box, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import Start from "./Start";
import Candidates from "./Candidates";
import CandidatesVideo from "./CandidatesVideo";
import CandidateChoice from "./CandidateChoice";
import JobAnnouncement from "./JobAnnouncement";
import Feedback from "./Feedback";
import {styled} from "@mui/material/styles";
import axios from "axios";
import {AUTHORIZED_URL_PREFIX, AxiosConfig} from "../../../Utils/Constants";
import {stopActivitySession, useUpdateActivitySession} from "../../../Utils/TimerUtils";



const Interview = () => {
    const testId = 'v001'
  const [isLoading, setIsLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0)
    const [isRunning, setIsRunning] = useState(false);

    const [candidatesResults, setCandidatesResults] = useState({
        candidate1: {
            option1: false,
            option2: false,
            option1correct: false,
            option2correct: false,
        },
        candidate2: {
            option1: false,
            option2: false,
            option1correct: true,
            option2correct: false,
        },
        candidate3: {
            option1: false,
            option2: false,
            option1correct: true,
            option2correct: true,
        },
        candidateChoice: '',
        correctCandidateChoice: "candidate3"
    })

    useUpdateActivitySession(testId, isRunning);

    const [isBackClicked, setIsBackClicked] = useState(false);
  const steps = [
      <Start/>,
      <JobAnnouncement/>,
      <Candidates/>,
      <CandidatesVideo/>,
      <CandidateChoice/>,
      <Feedback/>,
  ]

    const handleNextStep = () => {
        setCurrentStep(currentStep === steps.length - 1 ? 0 : currentStep + 1);
    }

    useEffect( () => {

        //check if playing the activity and keep timer active
        if ([1, 2, 3, 4].includes(currentStep)) {
           setIsRunning(true)
        }else {
            setIsRunning(false)
        }

        const sendData = async () => {
            //send the results
            if (currentStep === 5) {

                const results = {
                    id: testId,
                    type: "Assessment",
                    candidatesResults
                }
                if (isSuccess()) {
                    stopActivitySession(testId, true)
                } else {
                    stopActivitySession(testId, false)
                }

                const {data} = await axios.post(
                    `${AUTHORIZED_URL_PREFIX}${"/user/saveResults"}`,
                    {results: results},
                    AxiosConfig()
                )
                if (!data.success) {
                    console.log('error sending data to the server');
                }
            }
        }
        sendData();

    },[currentStep])

    const isSuccess = () => {
        if (candidatesResults.candidateChoice !== candidatesResults.correctCandidateChoice) {
            return false;
        }

        // Loop through the candidates and check if options match the correct options
        for (let key in candidatesResults) {
            if (key === "candidateChoice" || key === "correctCandidateChoice") {
                continue;
            }

            const candidate = candidatesResults[key];

            if (
                candidate.option1 !== candidate.option1correct ||
                candidate.option2 !== candidate.option2correct
            ) {
                return false;
            }
        }

        return true;
    }

    const handleBackToVideoClick = () => {
      setCurrentStep(3)
    }

    const componentProps = {
      handleNextStep: handleNextStep,
      candidatesResults: candidatesResults,
      setCandidatesResults: setCandidatesResults,
      setIsRunning: setIsRunning,
      testId: testId,
      isBackClicked: isBackClicked,
      setIsBackClicked: setIsBackClicked,
      setCurrentStep: setCurrentStep,
    }

    const stepWithProps = steps.map(step => React.cloneElement(step, componentProps));

    const currentStepToShow = stepWithProps[currentStep];

  return (
    <div className="lykioccs-main-content lykiocss-Valutazione eni-activities">
      {isLoading ? (
        <Loading />
      ) : (
        <div
          style={{ color: "white" }}
          className=" lykiocss-margin-top-2em"
        >
            {currentStepToShow}

        </div>
      )}
      <RightFooter />
    </div>
  );
};

export default Interview;
